<template>
  <v-overlay v-model="overlay" class="justify-center">
    <v-card max-width="666" width="90vw" class="mt-4 mt-md-12 pa-4">
      <v-row>
        <v-col cols="12" md="9">
          <h2 class="text-green success-title">{{ successTitle }}</h2></v-col
        >
        <v-col cols="12" md="3" class="d-flex align-center">
          <v-btn color="primary" @click="clearSuccess()" block>
            schliessen
          </v-btn></v-col
        >
      </v-row>
      <v-row>
        <v-col cols="12">
          <p class="success-message">{{ successMessage }}</p>
        </v-col>
      </v-row>
    </v-card>
  </v-overlay>
</template>

<script setup>
  import { computed } from "vue";
  import { useSuccessStore } from "@/stores/successStore";

  const successStore = useSuccessStore();

  const overlay = computed({
    get: () => !!successStore.load,
    set: (value) => !value && successStore.clearSuccess(),
  });

  const successTitle = computed(() => successStore.title || "Alle klar!");
  const successMessage = computed(() => successStore.message || "");
  function clearSuccess() {
    successStore.clearSuccess();
  }
</script>

<style scoped src="@/assets/styles/sfc/components/modules/SuccessOverlay.css"></style>
